import useSWR from 'swr'
import { isRealtimeError } from '../helpers/debugOptions'
import { useParams } from 'react-router-dom'

import {
  MULTIMAXI_REFRESH_INTERVAL,
  MULTIMAXI_SPLIT_MAX_AMOUNT_OF_STOPS,
} from '../constants'
import networkApi from '../data/network.api'

const fetcher = async ({ haltenummers }) => {
  if (isRealtimeError()) {
    console.log('Fake realtime error')
    throw new Error('RTKN debug error for realtime calls')
  }
  return networkApi.getMultipleStops(haltenummers)
}

export function useMultipleStops() {
  const { haltenummers } = useParams()
  const stopIds = haltenummers
    .split('+')
    .slice(0, MULTIMAXI_SPLIT_MAX_AMOUNT_OF_STOPS)

  const { data, error, isLoading } = useSWR(
    `multimaxi-split-stops-${haltenummers}`,
    (key) => fetcher({ key, haltenummers: stopIds }),
    {
      fallbackData: [],
      revalidateOnFocus: false,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        const errorTimeoutId = setTimeout(() => {
          revalidate({ retryCount })
          clearTimeout(errorTimeoutId)
        }, MULTIMAXI_REFRESH_INTERVAL)
      },
    },
  )

  return {
    stops: data,
    error,
    isLoading,
  }
}
